<app-mu-modal-dialog-layout [flagList]="processingData.flags" [title]="dialogTitle | translate" [showFlag]="processingData.showFlag">
  <div modalDialogContent class="p-col-12 mu-modal-text mu-without-padding">
    <ng-container *ngIf="!processingData.errorState">
      <div class="massive-loading--message" translate>{{ processingData.message }}</div>
      <p-progressBar [value]="processingData.value" [showValue]="true" [mode]="processingData.mode"></p-progressBar>
    </ng-container>
    <ng-container *ngIf="processingData.errorState">
      <div class="massive-loading--message" [innerHTML]="processingData.errorMessage | translate: processingData.errorData"></div>
    </ng-container>
  </div>
  <div modalDialogButton class="p-col-12 p-md-6 mu-modal-button mu-modal-button-right">
    <p-button *ngIf="processingData.errorState" [label]="'modal.close' | translate" class="mu-button" (click)="closeModalByError()">
    </p-button>
  </div>
</app-mu-modal-dialog-layout>
